import React from "react";
import { useNavigate } from "react-router-dom";
import { FileBarChart, FolderKanban } from "lucide-react";
import { useProjects } from "@/context/ProjectContext";
import { toast } from "sonner";
import api, { formatError } from "@/lib/api";
import { DeleteX } from "@/components/DeleteX";
import { BrandDocButton } from "@/components/BrandDocButton";
import { Button } from "@/components/ui/button";

export default function Reports() {
  const { projects: all, refresh } = useProjects();
  const projects = (all || []).filter((p) => !p.report_hidden);
  const hide = async (id) => {
    try { await api.patch(`/projects/${id}/meta`, { report_hidden: true }); await refresh(); toast.success("تم حذف التقرير من القائمة"); }
    catch (err) { toast.error(formatError(err.response?.data?.detail)); }
  };
  const navigate = useNavigate();
  return (
    <div className="space-y-6" data-testid="reports-page">
      <div>
        <h1 className="text-3xl font-extrabold font-heading">التقارير</h1>
        <p className="text-muted-foreground mt-1 text-sm max-w-2xl">
          تقارير شاملة لكل مشروع: الاستراتيجية الكاملة بمكوّناتها وأهدافها ومستوى تقدّم التنفيذ — قابلة للعرض والتنزيل (PDF) لتثقيف العميل ومتابعة الإنجاز.
        </p>
      </div>
      {(!projects || projects.length === 0) ? (
        <div className="glass rounded-2xl p-10 text-center text-muted-foreground" data-testid="reports-empty">
          لا توجد مشاريع بعد. أنشئ مشروعاً أولاً لعرض تقريره.
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {projects.map((p) => (
            <div key={p.id} className="relative glass rounded-2xl p-5 flex flex-col gap-3 min-w-0 overflow-hidden" data-testid={`report-project-${p.id}`}>
              <DeleteX testId={`delete-report-${p.id}`} className="absolute top-3 end-3" title="حذف هذا التقرير؟"
                desc="سيختفي التقرير من قسم التقارير، ويبقى المشروع ومحتواه محفوظاً." onConfirm={() => hide(p.id)} />
              <div className="flex items-center gap-3">
                {p.logo
                  ? <img src={p.logo} alt="" className="w-12 h-12 rounded-xl object-contain border border-border bg-white/5" />
                  : <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center text-primary"><FolderKanban className="w-5 h-5" /></div>}
                <div className="min-w-0">
                  <div className="font-bold truncate">{p.name}</div>
                  <div className="text-xs text-muted-foreground truncate">{p.business_type || (p.standalone ? "محتوى فردي" : "مشروع")}</div>
                </div>
              </div>
              <Button onClick={() => navigate(`/app/report/${p.id}`)} className="w-full gap-2 mt-auto" data-testid={`view-report-${p.id}`}>
                <FileBarChart className="w-4 h-4" /> عرض التقرير
              </Button>
              {!p.standalone && <BrandDocButton project={p} testId={`report-brand-doc-${p.id}`} size="default" className="w-full bg-accent hover:bg-accent/90 text-white" />}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
